import { render, staticRenderFns } from "./data-usage-detail.vue?vue&type=template&id=939a6640&scoped=true"
import script from "./data-usage-detail.vue?vue&type=script&lang=js"
export * from "./data-usage-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "939a6640",
  null
  
)

export default component.exports